import { useState } from "react";
import { Slider } from "./ui/slider";
import { AUTO_WASH } from "../lib/business";

const num = (s) => parseFloat(s.replace("$", ""));

export function SavingsCalculator({ price }) {
  const [washes, setWashes] = useState(4);
  const [tier, setTier] = useState(AUTO_WASH[1].name);
  const [fuel, setFuel] = useState(false);
  const w = AUTO_WASH.find((x) => x.name === tier);
  const each = num(fuel ? w.fuelPrice : w.price);
  const payg = washes * each;
  const save = payg - price;
  const breakEven = Math.ceil(price / each);

  return (
    <section className="mx-auto max-w-7xl px-6 pb-20" data-testid="savings-calculator">
      <div className="overline text-volt mb-3">Savings Calculator</div>
      <h2 className="font-head font-extrabold text-3xl md:text-4xl uppercase tracking-tight mb-10">How Much Could You Save?</h2>
      <div className="grid lg:grid-cols-2 gap-px bg-white/10 border border-white/10">
        <div className="bg-background p-8 space-y-8">
          <div>
            <div className="flex justify-between overline text-muted-foreground mb-4">
              <span>Washes per month</span><span className="text-white text-base" data-testid="savings-washes-value">{washes}</span>
            </div>
            <Slider data-testid="savings-washes-slider" min={1} max={30} step={1} value={[washes]} onValueChange={(v) => setWashes(v[0])} />
          </div>
          <div>
            <div className="overline text-muted-foreground mb-3">Wash you'd normally buy</div>
            <div className="grid grid-cols-2 gap-2">
              {AUTO_WASH.map((x) => (
                <button key={x.name} type="button" onClick={() => setTier(x.name)} data-testid={`savings-tier-${x.name.toLowerCase().replace(/\s/g, "-")}`}
                  className={`border px-4 py-3 text-left transition-colors ${tier === x.name ? "border-volt bg-volt/15" : "border-white/10 hover:border-white/30"}`}>
                  <div className="font-head font-bold uppercase text-sm">{x.name}</div>
                  <div className="overline text-muted-foreground">{fuel ? x.fuelPrice : x.price}</div>
                </button>
              ))}
            </div>
          </div>
          <label className="flex items-center gap-3 cursor-pointer text-sm tracking-wide">
            <input type="checkbox" checked={fuel} onChange={(e) => setFuel(e.target.checked)} data-testid="savings-fuel-toggle" className="w-4 h-4 accent-[hsl(var(--primary))]" />
            I usually fill up $5+ fuel (fuel discount price)
          </label>
        </div>
        <div className="bg-surface p-8 flex flex-col justify-center">
          <div className="grid grid-cols-2 gap-6 mb-8">
            <div>
              <div className="overline text-muted-foreground mb-2">Paying per wash</div>
              <div className="font-head font-black text-3xl" data-testid="savings-payg-total">${payg.toFixed(2)}</div>
            </div>
            <div>
              <div className="overline text-muted-foreground mb-2">Membership</div>
              <div className="font-head font-black text-3xl" data-testid="savings-member-total">${price}</div>
            </div>
          </div>
          <div className="overline text-volt mb-2">{save > 0 ? "You save every month" : "Membership pays off from"}</div>
          <div className="font-head font-black text-6xl md:text-7xl" data-testid="savings-result">
            {save > 0 ? `$${save.toFixed(2)}` : `${breakEven} washes`}
          </div>
          <p className="text-sm text-muted-foreground mt-4 tracking-wide" data-testid="savings-break-even">
            Membership pays for itself after {breakEven} {w.name} washes a month{save > 0 ? ` — that's $${(save * 12).toFixed(0)} a year back in your pocket.` : "."}
          </p>
        </div>
      </div>
    </section>
  );
}
